import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AdminGuard } from '../../shared/guard/admin.guard';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {

  isAdmin: boolean = false; // 🔥 Variável para controle do menu

  constructor(private adminGuard: AdminGuard, private router: Router) {}

  ngOnInit(): void {
    this.isAdmin = this.adminGuard.hasRole('Admin'); // 🔥 Verifica se o usuário tem a role "Admin"
  }
 
  isRouteActive(route: string): boolean {
    return this.router.url === route;
  }
}
